import { MODES } from "../constants";
import { parseJSONDocumentState } from "./json-parser";
import { parseJSON5DocumentState } from "./json5-parser";
import { parseYAMLDocumentState } from "./yaml-parser";
export const getDefaultParser = (mode) => {
    switch (mode) {
        case MODES.JSON:
            return parseJSONDocumentState;
        case MODES.JSON5:
            return parseJSON5DocumentState;
        case MODES.YAML:
            return parseYAMLDocumentState;
    }
};
